var chat4i = function(){
	var chatLinks = [].slice.call(document.querySelectorAll(".initChat")), 
	
	liveChat = function(e) {
		e.preventDefault();
		var userIdRequest = ajax({
			method: "POST",
			url: '/Header/GetUserID',
			timeout: 15000
		});
		userIdRequest.then(function(response, xhr){
			var UserID = "Anon_Web_User";
    	   		if(!response.Anonymous){
    	      			UserID = response.Email;
    	    		}
           		var url = "https://chat.4imprint.com/i3root/examples/bypassloginform/chatorcallback.html?chatUsername=" + UserID;
    	    		window.open(url, "OnlineHelp", "status=0,width=750,height=550, top=10, left=10, scrollbars=1");
		});
	},
	isOfficeOpen = function(){
		if (chatLinks.length) {
			var officeOpenRequest = ajax({
				method: "POST",
				url: '/Header/IsOfficeOpen',
				timeout: 15000
			});
			officeOpenRequest.then(function(response, xhr){
				 if (!response.OfficeOpen) {
				 	chatLinks.forEach(function(el, index, array){
						el.classList.add("hide");
					});
		                }
			});
		}
	},
	addChatEvents = function(){
		if(chatLinks.length){
			chatLinks.forEach(function(el, index, array){
				el.removeEventListener("click", liveChat);
				el.addEventListener("click", liveChat);
			});
		}
	},
	init = function(){
		isOfficeOpen();
		addChatEvents();
	};

	return{
		init: init
	};
};